import styled from 'styled-components';
import PlayerMatchupPattern from '@mlb/react-patterns/v4/components/PlayerMatchup/playerMatchup';
import {
    PlayerNameWrapper,
    PlayerPregameWrapper,
    PlayerDataWrapper,
    PlayerStatsWrapper,
    PlayerInfoWrapper
} from '@mlb/react-patterns/v4/components/PlayerMatchup/playerMatchup.style';
import { ImageWrapper } from '@mlb/react-patterns/v4/components/Image/image.style';
import { liveViewsTypes } from '../../themes/liveViewsTypes';

const { SINGLENARROW, FULLNARROW } = liveViewsTypes;
const PREVIEW = 'preview';

const PlayerMatchup = styled(PlayerMatchupPattern)`
    ${({ $type, $gameState }) => {
        if ($gameState === PREVIEW) {
            return `
                    width: 96px;
                `;
        } else {
            return `
                    width: ${$type === SINGLENARROW ? '48px' : '64px'};
                `;
        }
    }};

    ${ImageWrapper} {
        display: block;
        ${({ $type, $gameState }) => {
        if ($type !== 'condensed') {
            if ($gameState === PREVIEW) {
                return `
                    width: 96px;
                `;
            } else {
                return `
                    width: ${$type === SINGLENARROW ? '48px' : '64px'};
                `;
            }
        }
}};
    }

    ${PlayerNameWrapper} {
        font-size: 14px;
        color: var(--gameday-primary-font-color);
        font-weight: 700;
        display: inline-block;
        white-space: nowrap;
        margin-top: 4px;
        ${({ $gameState }) => ($gameState !== PREVIEW ? 'line-height: 14px;' : 'height: 21px;')}
    }

    ${PlayerPregameWrapper} {
        font-size: 12px;
        font-weight: 500;
        line-height: 12px;
        display: inline-block;
        color: var(--gameday-secondary-font-color);
        margin-right: 0;
        margin-left: 3px;
        margin-top: 5px;
    }

    &.right {
        ${PlayerDataWrapper} {
            ${({ $type, $gameState }) => {
                if ($type === SINGLENARROW || $type === FULLNARROW) {
                    return `
                        padding-right: 0px;
                        `;
                } else {
                    return `
                        padding-right: ${$gameState === PREVIEW ? '0' : '16px'};
                    `;
                }
             }};
        }

        ${PlayerStatsWrapper} {
            ${({ $type, $gameState }) => {
                if ($type === SINGLENARROW || $type === FULLNARROW) {
                    return `
                        justify-content: center;
                         text-align: center;
                    `;
                } else {
                    return `
                        justify-content: flex-end;
                        text-align: ${$gameState === PREVIEW ? 'center' : 'right'};
                    `;
                }
            }};
        }

        ${PlayerInfoWrapper} {
            flex-flow: row;
            justify-content: ${({ $type }) => ($type === SINGLENARROW || FULLNARROW ? 'center' : 'flex-end')};

            ${PlayerPregameWrapper} {
                margin-right: 0;
                margin-left: 3px;
                color: var(--gameday-secondary-font-color);
            }
        }
    }

    &.left {
        ${PlayerDataWrapper} {
            ${({ $type, $gameState }) => {
            if ($type === SINGLENARROW || $type === FULLNARROW) {
                return `
                    padding-left: 0px;
                `;
            } else {
                return `
                    padding-left: ${$gameState === PREVIEW ? '0' : '10px'};
                `;
            }
            }};
        }
    }

    ${PlayerInfoWrapper} {
        white-space: nowrap;
        margin:0;
    }

`;

export default PlayerMatchup;
